/* eslint-disable @typescript-eslint/no-unused-vars */
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { useQueryClient } from "@tanstack/react-query"
import { useState } from "react"

import DialogProvider from "@components/dialog_provider"
import { useCustomerPageContext } from "@contexts/customer"
import { deleteCustomerMutation } from "@domain/customer/infos"
import { showErrorToast } from "@utils/toast"

export default function DeleteCustomer() {
  const {
    translate,
    selectedCustomerId,
    toggleDeleteCustomerDialogOpen,
    isDeleteCustomerDialogOpen,
    me
  } = useCustomerPageContext()
  const queryClient = useQueryClient()
  const [loading, setLoading] = useState(false)

  function handleClose() {
    if (loading) {
      return
    }
    toggleDeleteCustomerDialogOpen?.()
  }

  async function onSubmit() {
    if (!selectedCustomerId) return
    setLoading(true)

    const {
      isSuccess,
      errorMessage,
      data: responseData
    } = await deleteCustomerMutation({
      customerId: selectedCustomerId
    })
    if (!isSuccess || !responseData) {
      showErrorToast(String(errorMessage))
      return
    }

    queryClient.invalidateQueries({ queryKey: ["customer-data-table"] })
    setLoading(false)
    handleClose()
  }

  return (
    <DialogProvider
      title={translate("delete_customer_title")}
      leftButton={{
        text: translate("cancel"),
        color: "secondary",
        onClick: handleClose,
        disabled: loading
      }}
      rightButton={{
        text: translate("delete"),
        color: "error",
        onClick: onSubmit,
        loading: loading,
        disabled: !selectedCustomerId
      }}
      isOpen={!!isDeleteCustomerDialogOpen}
      setClose={handleClose}
      size="small"
    >
      <Stack flex={1} gap={1} justifyContent={"center"} alignItems={"center"}>
        <Typography>{translate("delete_customer_description")}</Typography>
      </Stack>
    </DialogProvider>
  )
}
